export { ChevronRight as default } from './ChevronRight';
